import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Validaciones from "./pages/Validaciones";
import Contacto from "./pages/Contacto";
import ReporteCompleto from "./pages/ReporteCompleto";
import Admin from "./pages/Admin";
import Historial from "./pages/Historial";

function App() {
  const [user, setUser] = useState(null);

  // Check for saved user on app start
  useEffect(() => {
    const savedUser = localStorage.getItem('nika-user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('nika-user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('nika-user');
    localStorage.removeItem('nika-auth-token');
  };

  // Protected Route wrapper
  const ProtectedRoute = ({ children }) => {
    if (!user) {
      return <Login onLogin={handleLogin} />;
    }
    return children;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Navbar user={user} onLogout={handleLogout} />
          
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home user={user} />} />
              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route path="/register" element={<Register onLogin={handleLogin} />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard user={user} />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/validaciones" 
                element={
                  <ProtectedRoute>
                    <Validaciones />
                  </ProtectedRoute>
                } 
              />
              <Route path="/contacto" element={<Contacto />} />
              <Route 
                path="/reporte-completo" 
                element={
                  <ProtectedRoute>
                    <ReporteCompleto />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <Admin user={user} />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/historial"
                element={
                  <ProtectedRoute>
                    <Historial user={user} />
                  </ProtectedRoute>
                }
              />
              
              {/* Catch all route for 404 */}
              <Route path="*" element={
                <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
                    <p className="text-gray-600 mb-4">Página no encontrada</p>
                    <a href="/" className="text-blue-600 hover:text-blue-500">
                      Volver al inicio
                    </a>
                  </div>
                </div>
              } />
            </Routes>
          </main>
          
          <Footer />
        </div>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;